import React ,{ useState } from 'react';
import { useLocation } from 'react-router-dom';
import DocumentTitle from '../../../components/DocumentTitle/DocumentTitle';
import { editionStepsAPC } from '../../../utils/texts';
import ApcStepper from '../../../components/APC/StepperAPC/ApcStepper';
import StepOne from '../../../components/APC/Edition/Steps/StepOne';
import StepTwo from '../../../components/APC/Edition/Steps/StepTwo';
import StepThree from '../../../components/APC/Edition/Steps/StepThree';
const Edition = () => {
    const state = useLocation();
    const [activeStep, setActiveStep] = useState(1);
 ;
    const [ paiement ,setPaiement ] = useState({
        typeDemandeur: '',
        id:state.state.id,
        demandeur:{
        fullName:'',
        adresse: '',
        telephone:'',
        email: '',
        nina:'',
        denominationSociete:'',
        rccm: '',
       },
       infovehicule:{ 
        marque: '',
        modele: '',
        numeroChassis:[],
        categorie: '',  
        ptac: 0,
        dateMiseCirculation:'',
        paysProvenance:'Belgique',
        paysDestination:'Guinée',
        dossier:[] ,
        poidsTotalRoulant:0,
        poidsAVide:0,
        puissanceFiscale:0,
        chargeUtile:0,
        couleur:'',
        otherColor:"",
        loadedDossier:""
       }
    })
    const handleInput = (e) => {
        const { name, value } = e.target;
      
          // Special handling for numeroChassis
      if (name === 'numeroChassis') {
        setPaiement(prev => ({
          ...prev,
          infovehicule: {
            ...prev.infovehicule,
            numeroChassis: [value?.toUpperCase()] // Always maintain as array with single item
          }
        }));
        return;
      }
      if (name === 'otherColor') {
        setPaiement(prev => ({
          ...prev,
          infovehicule: {
            ...prev.infovehicule,
           // couleur: '',
            [name]: value // Always maintain as array with single item
          }
        }));
        return;
      }
      if (name === 'couleur') {
        setPaiement(prev => ({
          ...prev,
          infovehicule: {
            ...prev.infovehicule,
            couleur: value,
            otherColor: ''
          }
        }));
        return;
      }
        // Check if the field is in the top level (like typeDemandeur)
    
        if (name in paiement) {
          setPaiement({
            ...paiement,
            [name]: value
          });
        } 
        // Check if the field is in the demandeur object
        else if (name in paiement.demandeur) {
          setPaiement({
            ...paiement,
            demandeur: {
              ...paiement.demandeur,
              [name]: value
            }
          });
        }
        // Check if the field is in the infovehicule object
        else if (name in paiement.infovehicule) {
         
          setPaiement({
            ...paiement,
            infovehicule: {
              ...paiement.infovehicule,
              [name]: name === 'ptac' ? Number(value) : value // Convert to number if it's ptac
            }
          });
        }
      };
    const nextStep = () => {
        if( activeStep <= 4 )
          setActiveStep((s) => s + 1)
      }  
      const prevStep = () => {
        if( activeStep >= 1 ){
            setActiveStep((s) => s - 1);
        }
      } 
  const stepPage = () => {
    switch(activeStep){
        case 1:
            return <StepOne
                      nextStep={nextStep}
                      paiement={paiement}
                      setPaiement={setPaiement}
                      handleInput={handleInput}
                   />;
        case 2:
            return <StepTwo 
                        nextStep={nextStep}
                        prevStep={prevStep}
                        paiement={paiement}
                        setPaiement={setPaiement}
                        handleInput={handleInput}
                   />;
        case 3:
            return <StepThree
                        prevStep={prevStep}
                        paiement={paiement}
                        setPaiement={setPaiement}
                        handleInput={handleInput}
                   />;
        default:
            return <StepOne />;
    }
  }
  
  return (
    <div className='payment page'>
        <DocumentTitle title="Edition de l'Attestation d'enregistrement primaire" /> 
        <div className="header">
            <h3>Edition de l'Attestation d'enregistrement primaire"</h3>
            <p>Suivez les trois étapes suivantes pour editer l'attestation.</p>
        </div>
        <div className="payment-zone">
           <div className="payment-steps">
             <ApcStepper steps={editionStepsAPC} activeStep={activeStep} />
           </div> 
           <div className="payment-form">
               { stepPage() }
           </div> 
        </div>
    </div>
  )
}

export default Edition